import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Observable, map } from "rxjs";

import { API_Response, GetPagedResponse, TableOptions } from "../../interfaces";

@Injectable({
  providedIn: "root",
})
export class TableService {
  private http = inject(HttpClient);
  private translation = inject(TranslateService);
  private toastrService = inject(ToastrService);

  private body: TableOptions["bodyOptions"] = {
    pageNumber: 1,
    pageSize: 10,
    orderByValue: [{ colId: "CreatedDate", sort: "desc" }],
    filter: null,
  };

  searchNew$ = new BehaviorSubject(null);

  getData(url: string) {
    return this.http.get<API_Response<Record<string, unknown>[]>>(`${url}`);
  }

  postData(url: string, body?: TableOptions["bodyOptions"]) {
    return this.http.post<GetPagedResponse<Record<string, unknown>[]>>(`${url}`, body ? body : this.body);
  }

  delete<T = boolean>(url: string, id: string): Observable<T> {
    return this.http.delete<API_Response<T>>(`${url}/${id}`).pipe(
      map((event) => {
        this.alertHandling(event);
        return event.data;
      }),
    );
  }

  private alertHandling(event: API_Response<unknown>) {
    if (event.statusCode) {
      if (event.statusCode.toString().startsWith("2")) {
        this.toastrService.success(event.message ? this.translation.instant(`BE_VALIDATION.${event.message}`) : "Successfully Done...");
      } else {
        this.toastrService.error(event.message ? this.translation.instant(`BE_VALIDATION.${event.message}`) : "!NOT HANDLED ERROR!");
      }
    }
  }
}
